export default (element: any) =>
  element.dataset.element === 'remove-passenger-input'
